import { LOAD_CONFIG_DATA_MODEL_SUCCESS } from '../../../actions/app/index.tsx';
import { SET_COLUMNS } from '../../../actions/columns/index.tsx';
import type { Action } from '../../../types.tsx';
import type { ColumnEntityState } from './types.tsx';

const defaultState: ColumnEntityState = null;

export default function columnReducer(
	state: ColumnEntityState = defaultState,
	action: Action,
): ColumnEntityState {
	switch (action.type) {
		case LOAD_CONFIG_DATA_MODEL_SUCCESS: {
			return action.payload.columns;
		}
		case SET_COLUMNS:
			return action.payload.columns;
		default:
			return state;
	}
}
